<template>
  <div v-show="show" class="ibox float-e-margins">
    <div class="ibox-title">
      <h5>タグ<small></small></h5>
    </div>
    <div class="ibox-content">
        <div class="form-group">
          <label>名称</label>
          <input type="text" class="form-control" v-model="tag.name" >
          <p class="text-danger" v-show="error" v-if="!validation.name">名称が未入力です</p>
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-block" v-on:click="post">新規タグ</button>
          <p class="text-info" v-show="success" >更新しました。</p>
        </div>
    </div>
  </div>

</template>

<script>
  import Api from '@/service/Api.vue'
  import DismissableAlert from '@/components/DismissableAlert.vue'
  export default {
    created: function () {
      this.show = true
    },
    data () {
      return {
        show: false,
        title: '',
        tag: {
          name: ''
        },
        success: false,
        error: false
      }
    },
    methods: {
      post: function () {
        if (this.isValid) {
          var tag = this.tag
          Api.postTag(tag).then(this.clear)
        }
      },
      clear: function (response) {
        if (response.status === 200) {
          this.tag.name = ''
          this.success = true
          this.error = false
          this.$emit('init')
        }
      }
    },
    computed: {
      validation: function () {
        return {
          name: !!this.tag.name.trim()
        }
      },
      isValid: function () {
        var validation = this.validation
        this.success = false
        this.error = !Object.keys(validation).every(function (key) {
          return validation[key]
        })
        return !this.error
      }
    },
    components: {
      DismissableAlert
    }
  }
</script>




// WEBPACK FOOTER //
// TagAppend.vue?d30fe56a